import { idPrefixes } from '@/enums/signup'
import { defaultState as womenDefaultState } from '@/enums/womenSignup'
import { Orientations } from '@/enums/products'
import { MembershipTypes } from '@/enums/member'

/**
 * Complements the ID values where needed
 *
 * @param props
 */
export const mapToProspectProps = (props = {}) => ({
  ...props,
  ...(props.prospectId ? { id: `${idPrefixes.prospect}${props.prospectId}` } : {}),
  ...(props.orientation ? { membershipProductGroup: `${idPrefixes.product_group}${props.orientation}` } : {}),
  ...(props.freeOrientation ? { freeProductGroup: `${idPrefixes.product_group}${props.freeOrientation}` } : {}),
  ...(props.size && props.size.reference ? { size: `${idPrefixes.size}${props.size.reference}` } : {}),
  ...(props.selectedBoxerId ? { design: `${idPrefixes.design}${props.selectedBoxerId}` } : {}),
  ...(props.country ? { country: `${idPrefixes.country}${props.country}` } : {}),
  ...(props.annex ? { houseNumberAddition: props.annex } : {}),
  metadata: {
    ...(props.everflowTransactionID
      ? {
          everflow: {
            transaction_id: props.everflowTransactionID,
            ...(props.everflowSubIDs ? { sub_ids: props.everflowSubIDs } : {}),
            ...(props.everflowSourceID ? { source_id: String(props.everflowSourceID) } : {}),
            ...(props.everflowAffiliateID ? { aff_id: props.everflowAffiliateID } : {})
          }
        }
      : {})
  }
})

/**
 * Complements the ID values where needed
 *
 * @param props
 */
export const mapToWomenProspectProps = (props = {}) => ({
  firstName: props.firstName,
  lastName: props.lastName,
  email: props.email,
  password: props.password,
  locale: props.locale,
  referralCode: props.referralCode,
  productGroupSizeDesigns: props.productGroupSizeDesigns,
  country: `${idPrefixes.country}${props.country}`,
  membershipType: `${idPrefixes.membershipType}${props.membershipType}`,
  promotionalEmailsEnabled: props.promotionalEmailsEnabled,
  metadata: {
    ...(props.everflowTransactionID
      ? {
          everflow: {
            transaction_id: props.everflowTransactionID,
            ...(props.everflowSubIDs ? { sub_ids: props.everflowSubIDs } : {}),
            ...(props.everflowSourceID ? { source_id: String(props.everflowSourceID) } : {}),
            ...(props.everflowAffiliateID ? { aff_id: props.everflowAffiliateID } : {})
          }
        }
      : {}),
    ...(props.scCid
      ? {
          snapchat: {
            clickId: props.scCid,
            ...(props.utmCampaign ? { campaign: props.utmCampaign } : {}),
            ...(props.utmMedium ? { medium: props.utmMedium } : {})
          }
        }
      : {}),
    ...(props.fbClickId
      ? {
          facebook: {
            clickId: props.fbClickId,
            browserId: props.browserId
          }
        }
      : {}),
    ...(props.utmSource || props.utmMedium || props.utmCampaign || props.landingPageUrl || props.otaAttribution
      ? {
          tracking: {
            ...(props.utmSource ? { utmSource: props.utmSource } : {}),
            ...(props.utmMedium ? { utmMedium: props.utmMedium } : {}),
            ...(props.utmCampaign ? { utmCampaign: props.utmCampaign } : {}),
            ...(props.landingPageUrl ? { landingPageUrl: props.landingPageUrl } : {}),
            ...(props.otaAttribution ? { otaAttribution: props.otaAttribution } : {})
          }
        }
      : {}),
    tags: {
      waitingDays: props.waitDays,
      signupThankYouPageVariant: props.signupThankYouPageVariant
    },
    ...(props.userVariants ? { variants: props.userVariants } : {})
  }
})

export const mapWomenAddressToProspectProps = (address = {}) => ({
  ...address,
  houseNumberAddition: address.annex,
  country: `${idPrefixes.country}${address.country}`,
  ...(address.loqateAddressId ? { loqateAddressId: address.loqateAddressId } : {})
})

/**
 * Removes the address data of the object
 *
 * @param props
 */
export const stripAddressProps = (props = {}) => {
  // eslint-disable-next-line
  const { building, floor, street, country, houseNumber, annex, postalCode, city, region, ...prospectWithoutAddress } = props

  return prospectWithoutAddress
}

export const getWomenProductGroupSizeDesigns = (signupForm = womenDefaultState) => {
  const top = {
    productGroupSize: `${idPrefixes.productGroupSizes}${signupForm[Orientations.womenbralette].size.reference}`,
    freeProductGroupSize: `${idPrefixes.productGroupSizes}${signupForm[Orientations.womenbralette].size.reference}`,
    freeProductDesign: `${idPrefixes.designReference}${signupForm[Orientations.womenbralette].design.slug}`
  }

  const hipster = {
    productGroupSize: `${idPrefixes.productGroupSizes}${signupForm[Orientations.womenhipster].size.reference}`,
    freeProductGroupSize: `${idPrefixes.productGroupSizes}${signupForm[Orientations.womenhipster].size.reference}`,
    freeProductDesign: `${idPrefixes.designReference}${signupForm[Orientations.womenhipster].design.slug}`
  }

  return [top, hipster]
}

export const getMembershipTypeUrl = (membershipTypeReference = MembershipTypes.menOriginals) => {
  if (membershipTypeReference === MembershipTypes.menOne) {
    return 'men-one'
  }

  if (membershipTypeReference === MembershipTypes.boysOriginals) {
    return 'boys-originals'
  }

  return 'men-originals'
}
